import { emailTemplateSchema } from "@redotech/redo-marketing-templates-common/email-template";
import * as zExt from "@redotech/rpc/ext";
import { schemaKey } from "@redotech/zod-util/schema-key";
import * as z from "zod";

const byOriginInput = z.object({ originTemplateId: zExt.objectId() });
const output = emailTemplateSchema.extend({ isOrigin: z.boolean().optional() });

export const getEmailTemplate = {
  name: "getEmailTemplate" as const,
  description: `Reads an email template by id. With ${schemaKey(byOriginInput, "originTemplateId")}, reads the team's copy of that origin template, or the origin itself (${schemaKey(output, "isOrigin")}: true) when the team has no copy.`,
  mutates: false,
  input: z.union([z.object({ id: zExt.objectId() }), byOriginInput]),
  output,
};
